import React from 'react';
import {Col, Form, Row} from "react-bootstrap";
import {useFormContext} from "react-hook-form";

const HorizontalFormMultiCheck = ({controlId, label, options, readMode, validation, ...rest}) => {
    const {register, formState: {errors}} = useFormContext()
    return (
        <fieldset>
            <Form.Group as={Row} className={"mb-1"}>
                <Form.Label as="legend" column xs={7} sm={3}>{label}</Form.Label>
                <Col>
                    {options.map(o => {
                        return <Form.Check
                            key={o.value}
                            disabled={readMode}
                            {...rest}
                            className={errors[controlId] ? "is-invalid" : ""}
                        >
                            <Form.Check.Input isInvalid={!!errors[controlId]}
                                              value={o.value}
                                              disabled={readMode}
                                              {...register(controlId, validation)}
                            />
                            <Form.Check.Label className={"mb-0"}>{o.label}</Form.Check.Label>
                        </Form.Check>
                            })}
                    {!!errors[controlId] && <Form.Control.Feedback type={"invalid"} className={"mb-1"}>{errors[controlId].message}</Form.Control.Feedback>}
                </Col>
            </Form.Group>
        </fieldset>
    )
}
export default HorizontalFormMultiCheck